export default {
  presenter: 'becvarik',
  title: 'Systém pro domácí buildění',
  subtitle: 'začátečníci',
  text: `
Každý se s tím setkal, pár řádků skriptů se mění v aplikace, aplikace v projekt se spoustou
závislostí a podpůrných skriptů. Najednou člověk spravuje verze, automaticky testuje a sbírá
podněty pro budoucí rozvoj. Pojďmě se podívat na možnosti správy repository a continous integration
v domácím prostředí, povězme si proč o těchto nástrojích uvažovat i jak a kde je používat.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/becvarik-domaci-bydleni.js